import { makeStyles, Box, Grid, Typography } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import SWLink from '../_components/SWLink'

const CUSTOM_FONT_SW = 'CustomFont-SW'

const useStyles = makeStyles<Theme, ScheduleConsultationProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    },
    inner: {
      padding: '50px',
      background: '#fff',
      [theme.breakpoints.down('xs')]: {
        padding: '30px 15px'
      }
      // display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'center',
      // flexDirection: 'column',
    },
    content: {
      [theme.breakpoints.down('sm')]: {
        marginLeft: '-28px',
        alignItems: 'center'
      },
      [theme.breakpoints.down('xs')]: {
        marginLeft: '0px',
        alignItems: 'center'
      }
    },
    preTitle: {
      marginBottom: '10px',
      fontFamily: CUSTOM_FONT_SW,
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '16px',
      letterSpacing: '1.5px',
      textTransform: 'uppercase'
    },
    title: {
      fontFamily: CUSTOM_FONT_SW,
      fontSize: '44px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '48px',
      letterSpacing: '-1.5px',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center'
      }
    },
    description: {
      marginTop: '10px',
      fontFamily: CUSTOM_FONT_SW,
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '-0.5px',
      [theme.breakpoints.down('md')]: {
        marginLeft: '20px'
      },
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center'
      }
    },
    image: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        justifyContent: 'center'
      }
    }
  }),
  { name: 'ScheduleConsultation' }
)

export interface ScheduleConsultationProps {
  classes?: StyleClasses<typeof useStyles>
}

function ScheduleConsultation(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <Box className={classes.inner}>
        <Grid container alignItems="center" direction={'row'} spacing={2}>
          <Grid item xs={12} md={6} xl={6} className={classes.image}>
            <img
              src={'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/color-consultation.png'}
              style={{ maxWidth: '100%', maxHeight: '349px' }}
            />
          </Grid>
          <Grid item xs={12} md={5} xl={6} container direction="column" className={classes.content}>
            <Grid item>
              <Typography variant="h1" className={classes.title}>
                Choose the Perfect Color for Your Delivery
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body1" className={classes.description}>
                {'Find the right hue for your home with our collection of tools and resources.'}
              </Typography>
            </Grid>
            <Grid item>
              <SWLink
                style={{ marginTop: '20px' }}
                href={'https://www.sherwin-williams.com/en-us/virtual-color-consultation'}
                label={'ASK OUR COLOR EXPERTS'}
                theme="dark"
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  )
}

export default ScheduleConsultation
